import React from 'react'

type Chunks = Record<string, unknown>

const patchLocalizationValues = (values: Record<string, any> = {}): Record<string, any> => ({
    ...values,
    p: (chunks: Chunks) => React.createElement('p', {}, chunks),
    span: (chunks: Chunks) => React.createElement('span', {}, chunks),
    div: (chunks: Chunks) => React.createElement('div', {}, chunks),
    b: (chunks: Chunks) => React.createElement('b', {}, chunks),
    i: (chunks: Chunks) => React.createElement('i', {}, chunks),
    strong: (chunks: Chunks) => React.createElement('strong', {}, chunks),
    em: (chunks: Chunks) => React.createElement('em', {}, chunks),
    small: (chunks: Chunks) => React.createElement('small', {}, chunks),
    u: (chunks: Chunks) => React.createElement('u', {}, chunks),
    br: () => React.createElement('br', {}),
    ul: (chunks: Chunks) => React.createElement('ul', {}, chunks),
    li: (chunks: Chunks) => React.createElement('li', {}, chunks),
    ...(values.link && { link: (chunks: Chunks) => React.createElement('a', values.link, chunks) }),
    ...(values.link2 && { link2: (chunks: Chunks) => React.createElement('a', values.link2, chunks) }),
})

export default patchLocalizationValues
